// src/services/customObject.js
import apiClient from './api'; // Your configured axios instance

// === RC CUSTOM OBJECTS ===

/**
 * GET: Fetches all stored RC custom objects for a specific org, grouped for the UI.
 * Corresponds to: GET /api/custom-objects/rc/:orgId
 */
export async function getRCCustomObjects(orgId) {
  const response = await apiClient.get(`/custom-objects/rc/${orgId}`);
  return response.data;
}

/**
 * POST (FETCH): Triggers a new data fetch from Salesforce for an RC org.
 * Corresponds to: POST /api/custom-objects/rc/:orgId/fetch
 */
export async function fetchRCCustomObjects(orgId) {
  const response = await apiClient.post(`/custom-objects/rc/${orgId}/fetch`);
  return response.data;
}

/**
 * POST (DEPLOY): Deploys selected custom object versions to a target RC org.
 * Corresponds to: POST /api/custom-objects/rc/deploy
 */
export async function deployRCCustomObjects(targetOrgId, versionIds) {
  const response = await apiClient.post('/custom-objects/rc/deploy', { targetOrgId, versionIds });
  return response.data;
}

/**
 * DELETE: Deletes a specific version of a custom object.
 * Corresponds to: DELETE /api/custom-objects/rc/version/:versionId
 */
export async function deleteRCCustomObjectVersion(versionId) {
  const response = await apiClient.delete(`/custom-objects/rc/version/${versionId}`);
  return response.data;
}
